import * as React from 'react';
import LegacyBillingContainer from 'containers/plansales/billing/LegacyBillingContainer';

const LegacyBilling = () => {
  return <LegacyBillingContainer />;
};

export default LegacyBilling;
